import { Component, Element, Event, EventEmitter, h, Method, Prop } from '@stencil/core';
import flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es'; // 🌍 Importar idioma español

@Component({
  tag: 'datetime-picker',
  shadow: false,
})
export class DatetimePicker {
  @Element() el: HTMLElement;
  @Prop() label: string;
  @Prop() name: string;
  @Prop() required: boolean = false;
  @Prop() value: string;
  @Prop() placeholder: string;
  @Prop() tooltip: string;
  @Prop() dateFormat: string = 'Y-m-d H:i';
  @Prop() minDate: string;
  @Prop() maxDate: string;
  @Prop() dataTab: string;

  @Event({ eventName: 'datetimeChange' }) datetimeChange: EventEmitter;

  private inputElement!: HTMLInputElement;
  private picker: flatpickr.Instance;

  componentDidLoad() {
    this.picker = flatpickr(this.inputElement, {
      enableTime: true,
      dateFormat: this.dateFormat,
      minDate: this.minDate,
      maxDate: this.maxDate,
      onChange: (_selectedDates, dateStr) => {
        this.datetimeChange.emit({ name: this.name, value: dateStr });
      },
      locale: Spanish, // 👉 Localización en español
      /* time_24hr: true, */
    });
  }

  @Method()
  async setDate(date: string) {
    this.picker.setDate(date);
  }

  render() {
    return (
      <>
        <label-tooltip label={this.label} tooltip={this.tooltip}></label-tooltip>
        <div class="input-group mb-3 flatpickr">
          <span class="input-group-text">
            <i class="bi bi-calendar3 text-primary"></i>
          </span>
          <input
            type="text"
            class="form-control-stencil form-control"
            data-tab={this.dataTab}
            id={this.name}
            name={this.name}
            required={this.required}
            placeholder={this.placeholder}
            title={this.tooltip}
            ref={el => (this.inputElement = el as HTMLInputElement)}
            lang="es"
          />
        </div>
      </>
    );
  }
}
